import React from 'react';
import { Grid, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NCRFormHeading from '../NCRFormHeading';
import NCRFormLabel from '../NCRFormLabel';
import AILabelBox from '../AILabelBox';
import { handleAIClick } from '../../../Helpers/NCRHelpers';
import NCRSelectField from '../NCRSelectField';
import NCRMultilineTextfields from '../NCRMultilineTextfields';
import NCRTextField from '../NCRTextField';

export default function SRCEntry({ content, onChange, onAiResponseChange }) {

  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Box sx={{ p: 3 }}>
            <Box>
              <NCRFormHeading isRequired={true} tooltipData={
                [
                  { title: "System Root Cause (SRC) Identification", description: "Options for common System Root Cause (SRC)s" },
                  { title: "Corrective Actions for System Root Cause (SRC)", description: "Describe the actions taken at the organizational or system level to prevent recurrence." },
                ]
              }>
                System Root Cause (SRC) Entry
              </NCRFormHeading>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={2}>
                        <NCRFormLabel>
                          SRC Identification:
                        </NCRFormLabel>
                      </Grid>
                      <NCRSelectField
                        size="medium"
                        name="system_root_cause_identification"
                        value={content.formData.system_root_cause_identification}
                        onChange={handleInputChange}
                        options={content.lookupTypes?.srcIdentification || []}
                        disabled={content.inputDisable}
                        error={!!content?.errors?.system_root_cause_identification}
                      />
                    </Grid>
                  </Box>
                  {content.formData.system_root_cause_identification === 'Other' &&
                    <Box sx={{ mb: 2 }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2}>
                          <NCRFormLabel>SRC Identification:</NCRFormLabel>
                        </Grid>
                        <NCRTextField
                          size='small'
                          sx={{ width: '340px' }}
                          multiline
                          name="system_root_cause_identification_other"
                          onChange={handleInputChange}
                          disabled={content.inputDisable}
                          value={content.formData.system_root_cause_identification_other || ''}
                          placeholder="Enter SRC identification"
                          error={!!content?.errors?.system_root_cause_identification_other}
                          maxLength={250}
                        />
                      </Grid>
                    </Box>
                  }
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: '50%', mr: 4 }}>
                <Grid item xs={4}>
                  <NCRFormLabel sx={{ mb: 1 }}>
                    Corrective Actions for System Root Cause (SRC):
                  </NCRFormLabel>
                </Grid>
                <Grid item xs={8}>
                  <NCRMultilineTextfields
                    name="corrective_actions_system_root_cause"
                    value={content.formData.corrective_actions_system_root_cause || ""}
                    onChange={handleInputChange}
                    disabled={content.inputDisable}
                    error={!!content?.errors?.corrective_actions_system_root_cause}
                    placeholder={!content.inputDisable ? 'Enter corrective actions for process root cause' : 'No data entered'}
                  />
                </Grid>
              </Box>
              {!content?.inputDisable && content?.label !== 'edit' &&
                <AILabelBox
                  label="corrective_actions_system_root_cause"
                  handleAIClick={(fieldName) => handleAIClick(fieldName, content, onAiResponseChange)}
                  aiResponse={content.aiResponse || {}}
                  onChange={onChange}
                />
              }
            </Box>
          </Box>
          <Divider sx={{ mt: 1.5, mb: 0.5 }} />
        </Box>
      </ThemeProvider >
    </>
  );
};
